module.exports = __webpack_public_path__ + "img/chong.82bad245.png";